
import { computed, defineComponent, reactive } from '@nuxtjs/composition-api';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import CatalogFilterHeader from '~/domains/catalog/components/CatalogFilterHeader.vue';
import CatalogFilterHeaderSorting from '~/domains/catalog/components/CatalogFilterHeaderSorting.vue';
import CatalogFilterHeaderFilters from '~/domains/catalog/components/CatalogFilterHeaderFilters.vue';

export default defineComponent({
  components: {
    CatalogFilterHeader,
    CatalogFilterHeaderFilters,
    CatalogFilterHeaderSorting,
  },
  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
    sorting: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { isGreater } = useBreakpoints(breakpointsTailwind);
    const showFilters = reactive({
      desktop: true,
      mobile: false,
    });

    const sortingValue = computed({
      get() {
        return props.sorting;
      },
      set(value) {
        emit('update:sorting', value);
      },
    });

    const toggleFilters = () => {
      const bp = isGreater('lg') ? 'desktop' : 'mobile';
      showFilters[bp] = !showFilters[bp];
    };

    return {
      sortingValue,
      showFilters,
      toggleFilters,
    };
  },
});
